import { useRef, useEffect } from 'react';

/**
 * useHandlerRef is a utility to "box" handler functions that would otherwise trigger
 * react hooks with invalidator to re-run. This is useful for input event handlers
 * that need to be attached to the DOM outside the react API.
 *
 * @param handler Any event handler function.
 * @returns The same handler boxed inside a ref to prevent it from triggering
 * useEffect and useCallback updates.
 */
function useHandlerRef(maybeHandler) {
  const handler = typeof maybeHandler !== 'undefined' ? maybeHandler : null;
  const handlerRef = useRef(handler);
  useEffect(() => {
    handlerRef.current = handler;
  }, [handler]);
  return handlerRef;
}

export { useHandlerRef as u };
//# sourceMappingURL=useHandlerRef-aaEiZjUW-aaEiZjUW.js.map
